import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { BehaviorSignalsResponse } from '@thiememeulenhoff/types';
import { BehaviorSignalEndpointsService } from './behavior-signal.endpoints.service';

@Injectable({
  providedIn: 'root',
})
export class BehaviorSignalService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(BehaviorSignalEndpointsService);

  public getBehaviorSignals(
    actor: string,
    contentIdentifier: string,
  ): Observable<BehaviorSignalsResponse> {
    const endpoint = this.#endpoints.getBehaviorSignals(
      actor,
      contentIdentifier,
    );
    return this.#http.get<BehaviorSignalsResponse>(endpoint);
  }
}
